<template>
  <div class="page-pay-notify-million-read-vip">
    <div class="page-pay-notify-million-read-vip-img">
      <img class="img"
           :src="pageData.product.src"
           alt="产品图片"
      />
    </div>
    <project-link :to="{ name: 'MillionReadUserGuide', query: { type: 'learn' } }">
      <div class="page-pay-notify-million-read-vip-guide-btn"
           v-ym-report:MILLION_VIP_NOTIFY_GUIDE_CLICK=""
      >
        查看使用指南
      </div>
    </project-link>
    <div class="page-pay-notify-million-read-vip-learn-btn"
         v-ym-report:MILLION_VIP_NOTIFY_GO_LEARNING_CLICK=""
         @click="handleClickLearn"
    >
      看过了，马上去阅读
    </div>
  </div>
</template>

<script>
  import ProjectLink from '@/components/ProjectLink';
  import { locationHref, projectJump } from '@/utils';

  export default {
    name: 'PayNotifyVip',
    metaInfo() {
      return {
        title: this.pageData.title,
      };
    },
    components: {
      ProjectLink,
    },
    props: {
      pageData: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        enterMyVipHint: '进入会员中心',
      };
    },
    computed: {
      id() {
        return this.pageData.product.id;
      },
    },
    methods: {
      handleClickLearn() {
        if (this.pageData.appLearnPath && this.pageData.appLearnPath !== '') {
          locationHref(this.pageData.appLearnPath);
          return;
        }
        projectJump({
          name: 'MillionReadLearnDetail',
        });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-pay-notify-million-read-vip {
    box-sizing: border-box;
    min-height: 100%;
    padding-top: @size-large;
    background: @color-white;

    &-img {
      width: 560px;
      height: 840px;
      display: block;
      margin: 0 auto 80px;
      box-shadow: 5px 8px 20px 0 rgba(255, 182, 54, 0.50);
      border-radius: 12px;
      overflow: hidden;
      .img {
        width: 100%;
        height: 100%;
      }
    }
    &-guide-btn {
      width: 424px;
      height: 88px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      color: @color-text-base;
      font-size: 32px;
      font-weight: @font-weight-strong;
      background: #fed100;
      border-radius: 44px;
    }
    &-learn-btn {
      display: block;
      margin-top: 34px;
      color: @color-text-light;
      font-size: @font-size-medium;
      line-height: 1;
      text-align: center;
    }
  }
</style>
